import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { AuthLayout } from "src/layouts/AuthLayout";
import { useLoginMutation } from "src/hooks/useLoginMutation";
import { LoginForm, LoginFormData } from "src/forms/LoginForm";
import axios from "axios";
import { auth } from "marvin-auth-kit";
import { useQueryClient } from "react-query";
import { baseDataKeys } from "src/query-keys";

export function LoginPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const queryClient = useQueryClient()

  const loginMutation = useLoginMutation();

  async function handleSubmit(values: LoginFormData) {
    await loginMutation.mutateAsync(values);
    // auth.applyInterceptors(axios);
    // queryClient.invalidateQueries(baseDataKeys.permissions);
    return navigate("/login-redirect");
  }

  return render();

  function render() {
    return (
      <AuthLayout>
        <StyledBox height="100%" display="flex" flexDirection="column" justifyContent="center">
          <Box pb={3}>
            <Typography variant="h3" component="h1">
              {t("label.welcome")}
            </Typography>
            <Typography variant="subtitle1" component="h1">
              {t("label.loginToContinue")}
            </Typography>
          </Box>

          <LoginForm onSubmit={handleSubmit} errors={loginMutation.error} isLoading={loginMutation.isLoading} />
        </StyledBox>
      </AuthLayout>
    );
  }
}

const StyledBox = styled(Box)`
  margin: 0 auto;

  ${({ theme }) => `
  padding: ${theme.spacing(8)};
  `}
`;
